export const COMPETENCY_EXPIRING_SOON_DAYS = 30;

export function formatCompetencyDate(value, fallback = "Not set") {
  if (!value) return fallback;
  const date = new Date(`${String(value).slice(0, 10)}T12:00:00`);
  if (Number.isNaN(date.getTime())) return fallback;
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function isCompetencyRequiredForRole(definition, jobRole) {
  if (!definition || !jobRole) return false;
  const roles = Array.isArray(definition.required_job_roles)
    ? definition.required_job_roles
    : [];
  const target = String(jobRole).trim().toLowerCase();
  return roles.some((role) => String(role || "").trim().toLowerCase() === target);
}

export function getCompetencyStatus(record, { required = false, now = new Date() } = {}) {
  if (!record) {
    return required
      ? { key: "missing", label: "Missing", tone: "red", attention: true }
      : { key: "not-held", label: "Not held", tone: "grey", attention: false };
  }

  if (!record.verified) {
    return {
      key: "pending",
      label: "Awaiting verification",
      tone: "orange",
      attention: true,
    };
  }

  if (!record.expires_on) {
    return { key: "valid", label: "Valid", tone: "green", attention: false };
  }

  const expiry = new Date(`${String(record.expires_on).slice(0, 10)}T23:59:59`);
  if (Number.isNaN(expiry.getTime())) {
    return { key: "valid", label: "Valid", tone: "green", attention: false };
  }

  const diffDays = Math.ceil((expiry.getTime() - now.getTime()) / (24 * 60 * 60 * 1000));

  if (diffDays < 0) {
    return { key: "expired", label: "Expired", tone: "red", attention: true, daysRemaining: diffDays };
  }

  if (diffDays <= COMPETENCY_EXPIRING_SOON_DAYS) {
    return {
      key: "expiring",
      label: diffDays === 0 ? "Expires today" : `Expires in ${diffDays} day${diffDays === 1 ? "" : "s"}`,
      tone: "orange",
      attention: true,
      daysRemaining: diffDays,
    };
  }

  return { key: "valid", label: "Valid", tone: "green", attention: false, daysRemaining: diffDays };
}

export function competencyStatusClass(status) {
  return `pguh-competency-status pguh-competency-status--${status?.tone || "grey"}`;
}
